import "./App.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  // Link
} from "react-router-dom";
import Header from "./components/Header";
import SingleProductPage from "./pages/SingleProductPage";
import ProductsPage from "./pages/ProductsPage";
import VendorProductsPage from "./pages/VendorProductsPage";
import LandingPage from "./pages/LandingPage";
import Footer from "./components/Footer";
import { useEffect, useState } from "react";
import NotFoundPage from "./pages/NotFoundPage";
import Cart from "./pages/Cart";
import Payment from "./pages/Payment";
import LoginPage from "./pages/LoginPage";

import SignupPage from "./pages/SignupPage";
import SignupPageVendor from "./pages/SignupPageVendor";

import { AuthProvider } from "./context/AuthContext";
import { OrderProvider } from "./context/OrderContext";
import VendorLoginPage from "./pages/VendorLoginPage";

function App() {
  const [atTop, setAtTop] = useState(true);

  useEffect(() => {
    document.addEventListener("scroll", () => {
      const scrollY = window.scrollY;
      if (scrollY > 20) {
        setAtTop(false);
      } else {
        setAtTop(true);
      }
    });
  }, []);
  return (
    <Router>
      <AuthProvider>
      <OrderProvider>
        <div>
          <Switch>
          <Route path="/products/vendor/:vendorId">
                <Header atTop={atTop} filled={true} />
                <VendorProductsPage />
                <Footer />
              </Route>
            <Route path="/products/:id" >
              <Header atTop={atTop}  filled={true}/>

                <SingleProductPage filled={true} />
                <Footer />
              </Route>
              <Route exact path="/products">
                <Header atTop={atTop} filled={true} />
                <ProductsPage />

                <Footer />
              </Route>
              
              <Route exact path="/">
                <Header atTop={atTop} />
                <LandingPage />

                <Footer />
              </Route>
              <Route path="/cart">
                <Header atTop={atTop} filled={true} />
                <Cart />
                <Footer />
              </Route>
              <Route path="/payment">
                <Header atTop={atTop} filled={true} />
                <Payment />
                <Footer />
              </Route>
              <Route path="/signup">
                <SignupPage />
              </Route>
              <Route path="/vendor-signup">
                <SignupPageVendor />
              </Route>
              <Route path="/vendor-login">
                <VendorLoginPage />
              </Route>
              <Route path="/login">
                <LoginPage />
              </Route>
              <Route component={NotFoundPage} />
            </Switch>
          </div>
        </OrderProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
